import { useState } from "react";
import { deleteUserAddressList } from "api/user";
import { DaumPostcodeEmbed } from "react-daum-postcode";
import useUserStore from "@store/useUserStore";
import "assets/scss/components/postcode.scss";

/**
 * 주소 입력 컴포넌트
 * @param {object} address 주소 객체
 *  {
        "label": "회사",
        "zipcode": "00000",
        "road_address": "서울 동산로 14길",
        "detail_address": "3층",
        "is_primary": true,
        "order": 1
    }
 * @param {function} saveAddress 주소 저장 함수
 * @returns
 */
const Postcode = ({ address, saveAddress }) => {
    const userInfo = useUserStore((state) => state.userInfo);
    const setUserInfo = useUserStore((state) => state.setUserInfo);
    const label = ["집", "회사", "기타"];
    const [isOpen, setIsOpen] = useState(false); // 우편번호 검색 모달창
    const [selectedLabel, setSelectedLabel] = useState(address.label || "");
    const [updateAddress, setUpdateAddress] = useState({
        zipcode: address.zipcode || "",
        road_address: address.roadAddress || "",
        detail_address: address.detailAddress || "",
    });
    const [isPrimary, setIsPrimary] = useState(address.is_primary || false);
    // 주소 선택 완료 후 호출되는 함수
    const completeHandler = (data) => {
        const newAddress = {
            zipcode: data.zonecode,
            road_address: data.roadAddress,
            detail_addres: "",
        };
        setUpdateAddress(newAddress);
        setIsOpen(false);
    };

    // 상세주소 입력 시 호출되는 함수
    const changeDetailAddress = (e) => {
        const newAddress = { ...updateAddress, detail_address: e.target.value };
        setUpdateAddress(newAddress);
    };

    const saveUserAddress = () => {
        if (selectedLabel === "") {
            alert("주소 유형을 선택해주세요.");
            return;
        }

        const params = {
            ...updateAddress,
            label: selectedLabel,
            is_primary: isPrimary,
            order: address.order || 1,
        };

        // 낙관적 업데이트를 위한 콜백 함수 호출
        // isPrimary가 true인 경우, 다른 주소들의 is_primary를 false로 설정해야 함
        saveAddress(address.id || null, params, isPrimary);
    };

    const deleteUserAddress = () => {
        deleteUserAddressList(address.id).then((res) => {
            setUserInfo({
                ...userInfo,
                addresses: userInfo.addresses.filter(
                    (addr) => addr.id !== address.id
                ),
            });
        });
        saveAddress();
        setTimeout(() => {
            window.location.reload();
        }, 500);
    };
    return (
        <>
            <div className="daum-postcode-wrap input-wrap">
                <div className="address-label-wrap">
                    {label.map((label) => (
                        <p
                            key={label}
                            className={`label ${
                                selectedLabel === label ? "selected" : ""
                            }`}
                            onClick={() => setSelectedLabel(label)}
                        >
                            {label}
                        </p>
                    ))}
                </div>
                <div className="input-form">
                    <div className="flex-row">
                        <input
                            className={`input`}
                            placeholder="우편번호"
                            value={updateAddress.zipcode}
                            readOnly
                        />
                        <button
                            className="btn btn-outline-gray200"
                            onClick={() => setIsOpen(true)}
                        >
                            주소 찾기
                        </button>
                    </div>
                </div>
                <div className="input-form">
                    <input
                        className={`input`}
                        value={updateAddress.road_address}
                        placeholder="주소"
                        readOnly
                    />
                </div>
                <div className="input-form">
                    <input
                        className={`input`}
                        placeholder="상세주소"
                        onChange={changeDetailAddress}
                        value={updateAddress.detail_address}
                    />
                </div>
                <div className="checkbox-input-wrap">
                    <input
                        type="checkbox"
                        className="primary-checkbox-input"
                        name="primary_address"
                        checked={isPrimary}
                        onChange={() => {
                            setIsPrimary(!isPrimary);
                        }}
                    />
                    <label className="agree-field" style={{ fontSize: "12px" }}>
                        대표 주소로 설정
                    </label>
                </div>
                <div className="btn-wrap-flex gap-8">
                    <button
                        className="btn btn-medium btn-purple500"
                        onClick={saveUserAddress}
                    >
                        저장
                    </button>
                    <button
                        className="btn btn-medium btn-gray200"
                        onClick={deleteUserAddress}
                    >
                        삭제
                    </button>
                </div>
            </div>
            {isOpen && (
                <div
                    className="daum-postcode-modal-overlay"
                    onClick={() => setIsOpen(false)}
                >
                    <div
                        className="daum-postcode-modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <DaumPostcodeEmbed onComplete={completeHandler} />
                    </div>
                </div>
            )}
        </>
    );
};

export default Postcode;
